import { useStore } from 'hooks/useStore';
import { observer } from 'mobx-react';
import ConceptSelector from './components/conceptSelector/ConceptSelector';
import MarketStrategy from './components/marketStrategy/MarketStrategySection';
import NdcStrategyTable from './components/ndcStrategyTable/ndcStrategyTable';
import classes from './fastsScreen.module.scss';
import { useFactsScreen } from './useFactsScreen';

const FactsScreen = () => {
  // Hook used for side effects (fetch on mount)
  useFactsScreen();
  const {
    FactsStore: { isConceptsListLoading, drugConceptsList },
  } = useStore();
  return (
    <div className={classes.factsScreenContainer}>
      {!isConceptsListLoading && drugConceptsList.length == 0 ? (
        <div
          style={{
            width: '100vw',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            paddingTop: '2rem',
          }}
        >
          <h2>Search a Molecule to see Facts</h2>
        </div>
      ) : (
        <>
          <ConceptSelector />
          <MarketStrategy />
          <NdcStrategyTable />
        </>
      )}
    </div>
  );
};

export default observer(FactsScreen);
